function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CropperImport = require('cropperjs');

var _require = require('preact'),
    h = _require.h,
    Component = _require.Component; // @TODO A silly hack that we can get rid of when moving to ESM.
// eslint-disable-next-line no-underscore-dangle


var Cropper = CropperImport.__esModule ? CropperImport.default : CropperImport;

module.exports = /*#__PURE__*/function (_Component) {
  _inherits(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _super.call(this, props);

    _this.granularRotateOnChange = function (ev) {
      var _this$state = _this.state,
          rotationAngle = _this$state.rotationAngle,
          rotationDelta = _this$state.rotationDelta;
      var pendingRotationDelta = Number(ev.target.value) - rotationDelta;
      cancelAnimationFrame(_this.granularRotateOnInputNextFrame);

      if (pendingRotationDelta !== 0) {
        var pendingRotationAngle = rotationAngle + pendingRotationDelta;
        _this.granularRotateOnInputNextFrame = requestAnimationFrame(function () {
          _this.cropper.rotateTo(pendingRotationAngle);
        });
      }
    };

    _this.state = {
      rotationAngle: 0,
      rotationDelta: 0
    };
    return _this;
  }

  _createClass(Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          opts = _this$props.opts,
          storeCropperInstance = _this$props.storeCropperInstance;
      this.cropper = new Cropper(this.imgElement, opts.cropperOptions);
      storeCropperInstance(this.cropper);

      if (opts.actions.granularRotate) {
        this.imgElement.addEventListener('crop', function (ev) {
          var rotationAngle = ev.detail.rotate;

          _this2.setState({
            rotationAngle: rotationAngle,
            // 405 == 360 + 45
            rotationDelta: (rotationAngle + 405) % 90 - 45
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cropper.destroy();
    }
  }, {
    key: "renderGranularRotate",
    value: function renderGranularRotate() {
      var i18n = this.props.i18n;
      var _this$state2 = this.state,
          rotationDelta = _this$state2.rotationDelta,
          rotationAngle = _this$state2.rotationAngle;
      return (// eslint-disable-next-line jsx-a11y/label-has-associated-control
        h("label", {
          "data-microtip-position": "top",
          role: "tooltip",
          "aria-label": "".concat(rotationAngle, "\xBA"),
          className: "uppy-ImageCropper-rangeWrapper uppy-u-reset"
        }, h("input", {
          className: "uppy-ImageCropper-range uppy-u-reset",
          type: "range",
          onInput: this.granularRotateOnChange,
          onChange: this.granularRotateOnChange,
          value: rotationDelta,
          min: "-45",
          max: "44",
          "aria-label": i18n('rotate')
        }))
      );
    }
  }, {
    key: "renderRevert",
    value: function renderRevert() {
      var _this3 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('revert'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          _this3.cropper.reset();

          _this3.cropper.setAspectRatio(0);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
      })));
    }
  }, {
    key: "renderRotate",
    value: function renderRotate() {
      var _this4 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        onClick: function onClick() {
          return _this4.cropper.rotate(-90);
        },
        "aria-label": i18n('rotate'),
        "data-microtip-position": "top"
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0V0zm0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M14 10a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a2 2 0 012-2h8zm0 1.75H6a.25.25 0 00-.243.193L5.75 12v7a.25.25 0 00.193.243L6 19.25h8a.25.25 0 00.243-.193L14.25 19v-7a.25.25 0 00-.193-.243L14 11.75zM12 .76V4c2.3 0 4.61.88 6.36 2.64a8.95 8.95 0 012.634 6.025L21 13a1 1 0 01-1.993.117L19 13h-.003a6.979 6.979 0 00-2.047-4.95 6.97 6.97 0 00-4.652-2.044L12 6v3.24L7.76 5 12 .76z"
      })));
    }
  }, {
    key: "renderFlip",
    value: function renderFlip() {
      var _this5 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('flipHorizontal'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this5.cropper.scaleX(-_this5.cropper.getData().scaleX || -1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
      })));
    }
  }, {
    key: "renderZoomIn",
    value: function renderZoomIn() {
      var _this6 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('zoomIn'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this6.cropper.zoom(0.1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24"
      }, h("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      }), h("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
      })));
    }
  }, {
    key: "renderZoomOut",
    value: function renderZoomOut() {
      var _this7 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('zoomOut'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this7.cropper.zoom(-0.1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
      })));
    }
  }, {
    key: "renderCropSquare",
    value: function renderCropSquare() {
      var _this8 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('aspectRatioSquare'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this8.cropper.setAspectRatio(1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
      })));
    }
  }, {
    key: "renderCropWidescreen",
    value: function renderCropWidescreen() {
      var _this9 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('aspectRatioLandscape'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this9.cropper.setAspectRatio(16 / 9);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M 19,4.9999992 V 17.000001 H 4.9999998 V 6.9999992 H 19 m 0,-2 H 4.9999998 c -1.0999999,0 -1.9999999,0.9000001 -1.9999999,2 V 17.000001 c 0,1.1 0.9,2 1.9999999,2 H 19 c 1.1,0 2,-0.9 2,-2 V 6.9999992 c 0,-1.0999999 -0.9,-2 -2,-2 z"
      }), h("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })));
    }
  }, {
    key: "renderCropWidescreenVertical",
    value: function renderCropWidescreenVertical() {
      var _this10 = this;

      var i18n = this.props.i18n;
      return h("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('aspectRatioPortrait'),
        "data-microtip-position": "top",
        onClick: function onClick() {
          return _this10.cropper.setAspectRatio(9 / 16);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M 19.000001,19 H 6.999999 V 5 h 10.000002 v 14 m 2,0 V 5 c 0,-1.0999999 -0.9,-1.9999999 -2,-1.9999999 H 6.999999 c -1.1,0 -2,0.9 -2,1.9999999 v 14 c 0,1.1 0.9,2 2,2 h 10.000002 c 1.1,0 2,-0.9 2,-2 z"
      }), h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      var _this$props2 = this.props,
          currentImage = _this$props2.currentImage,
          opts = _this$props2.opts;
      var actions = opts.actions;
      var imageURL = URL.createObjectURL(currentImage.data);
      return h("div", {
        className: "uppy-ImageCropper"
      }, h("div", {
        className: "uppy-ImageCropper-container"
      }, h("img", {
        className: "uppy-ImageCropper-image",
        alt: currentImage.name,
        src: imageURL,
        ref: function ref(_ref) {
          _this11.imgElement = _ref;
        }
      })), h("div", {
        className: "uppy-ImageCropper-controls"
      }, actions.revert && this.renderRevert(), actions.rotate && this.renderRotate(), actions.granularRotate && this.renderGranularRotate(), actions.flip && this.renderFlip(), actions.zoomIn && this.renderZoomIn(), actions.zoomOut && this.renderZoomOut(), actions.cropSquare && this.renderCropSquare(), actions.cropWidescreen && this.renderCropWidescreen(), actions.cropWidescreenVertical && this.renderCropWidescreenVertical()));
    }
  }]);

  return Editor;
}(Component);